import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { ActivationErrorType } from '../constants';

export interface ActivateWithCodeResponse {
    success: boolean;
    error?: string;
}

export const activateWithCode = async (activationCode: string) => {
    const integerActivationCode = parseInt(activationCode, 10);
    if (isNaN(integerActivationCode)) {
        throw new Error(ActivationErrorType.INVALID_CODE_FORMAT);
    }

    const { data } = await axios.post<ActivateWithCodeResponse>(pathfinder('activate_with_code'), {
        activation_code: integerActivationCode,
    });

    if (!data?.success) {
        throw new Error(ActivationErrorType.ACTIVATION_FAILED);
    }
};
